export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-brush/src/constant.js
// module id = ../../../../d3-brush/src/constant.js
// module chunks = 4